import { PinCode } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateField,
  useFormData,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";

const DEFAULT_PIN_LENGTH = 4;

interface DividedInputProps {
  fieldId: string;
}

function DividedInput({ fieldId }: DividedInputProps) {
  const findFieldById = useFormData((fd) => fd.findFieldById);
  const { translatorFor, dataTestIdPrefix } = useFormDataContext();

  const field = findFieldById(fieldId);
  const value = field.value.asString();
  const currentValue = value.hasBeenSet()
    ? value.value()
    : value.defaultValue();

  const translator = translatorFor(field);
  const label = translateField(translator, field, Suffix.LABEL);

  const errorMessage = field.violations().join(", ");

  const handleDividedInputChange = (newValue: string) => {
    field.setValue(newValue);
  };

  return (
    <PinCode
      dataTestId={`${dataTestIdPrefix}-${field.id()}`}
      errorMessage={errorMessage || ""}
      isError={Boolean(errorMessage)}
      label={label.toString()}
      length={DEFAULT_PIN_LENGTH}
      onChange={handleDividedInputChange}
      placeholder='-'
      value={currentValue}
    />
  );
}

export default DividedInput;
